const routes = [
  {
    path: "scouting",
    redirect: "scouting/poi",
    component: () => import("@/views/Scouting/Map.vue"),
    name: "scouting",
    children: [
      {
        path: "poi",
        component: () => import("@/views/Scouting/Poi.vue"),
        name: "scouting-poi",
      },
      {
        path: "poi/:id",
        component: () => import("@/views/Scouting/Poi/Show.vue"),
        name: "scouting-poi-show",
      },
      {
        path: "area/:id",
        component: () => import("@/views/Scouting/Area/Show.vue"),
        name: "scouting-area-show",
      },
      {
        path: "poi_search",
        component: () => import("@/views/Scouting/PoiSearch.vue"),
        name: "scouting-poi-search",
      },
      {
        path: "area_search",
        component: () => import("@/views/Scouting/AreaSearch.vue"),
        name: "scouting-area-search",
      },
    ],
  },
];

export default routes;
